import { makeAutoObservable } from 'mobx';

const MAX_NOTIFICATIONS = 50;

class NotificationsStore {
  notifications = [];
  unreadCount = 0;

  constructor() {
    makeAutoObservable(this);
  }

  /**
   * Called by the SignalR listener when an AuditNotification arrives.
   * @param {Object} notification  - AuditNotification payload from the backend
   */
  addNotification(notification) {
    // Prepend newest first
    this.notifications = [{ ...notification, read: false }, ...this.notifications].slice(
      0,
      MAX_NOTIFICATIONS
    );

    this.unreadCount = this.notifications.filter(n => !n.read).length;
  }

  markAllRead() {
    this.notifications = this.notifications.map(n => ({ ...n, read: true }));
    this.unreadCount = 0;
  }

  markRead(id) {
    this.notifications = this.notifications.map(n => (n.id === id ? { ...n, read: true } : n));
    this.unreadCount = this.notifications.filter(n => !n.read).length;
  }

  dismiss(id) {
    this.notifications = this.notifications.filter(n => n.id !== id);
    this.unreadCount = this.notifications.filter(n => !n.read).length;
  }

  dismissAll() {
    this.notifications = [];
    this.unreadCount = 0;
  }
}

const notificationsStore = new NotificationsStore();
export default notificationsStore;
